import React from 'react'

export default function DownloadIcon() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.5 5.83331V3.33331C17.5 2.41284 16.7538 1.66665 15.8333 1.66665L4.16667 1.66665C3.24619 1.66665 2.5 2.41284 2.5 3.33331V5.83331" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M13.3333 10L10 6.66667L6.66667 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M10 18.3333L10 6.66665" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    )
}
